import { gql } from "@apollo/client";
export default gql`
  mutation UpdateStudy($input: UpdateStudyInput!) {
    updateStudy(input: $input) {
      sucess
    }
  }
`;
